import React, { useCallback, useMemo } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Select } from 'ksnm-common-ui/lib/Select';
import { sortBy, uniqBy } from 'lodash-es';

import { reportGroupsStore } from '@stores/dictionaryStores/reportGroupsStore/reportGroupsStore';
import { reportPeriodsStore } from '@stores/dictionaryStores/reportPeriodsStore';

import styles from './Filter.module.scss';

export const Filter = observer((): JSX.Element => {
  const { reportGroups } = reportGroupsStore;
  const { reportPeriods, setFilters, filters, setSelectNode, setSelectedKeys } = reportPeriodsStore;

  const onClear = useCallback(() => {
    setFilters({});
    setSelectNode(null);
    setSelectedKeys([]);
  }, [setFilters, setSelectNode, setSelectedKeys]);

  const onChangeReportGroup = useCallback(
    (v) => {
      setFilters({ reportGroup: v });
      setSelectNode(null);
      setSelectedKeys([]);
    },
    [setFilters, setSelectNode, setSelectedKeys],
  );

  const reportGroupItems = useMemo(
    () =>
      sortBy(
        uniqBy(
          reportPeriods.filter((item) => !!item.reportGroupCode),
          'reportGroupCode',
        ).map((report) => {
          const group = reportGroups.find((item) => item.code === report.reportGroupCode);
          return {
            id: report.reportGroupCode,
            name: group ? `${group.code} - ${group.name}` : '',
          };
        }),
        'name',
      ),
    [reportGroups, reportPeriods],
  );

  return (
    <div className={styles.designFilters}>
      <div className={styles.items}>
        <Select
          items={reportGroupItems}
          placeholder="Группа версии"
          value={filters.reportGroup}
          onChange={onChangeReportGroup}
          size="small"
          showSearch
          className={styles.select}
        />
      </div>

      <Button onClick={onClear} disabled={!filters.reportGroup} icon={<Icon name="stop" />}>
        Сбросить фильтры
      </Button>
    </div>
  );
});
